import React from 'react';
import Typograpy from '../../../../../components/ui/Typography';
import { CircleXCloseMark, SearchIcon } from '../../../../../assets/Icons';
import Button from '../../../../../components/ui/Button';
import clsx from 'clsx';
import { AppStrings } from '../../../utils';
import { styles } from './styles';
import { RefreshCw, Plus } from 'lucide-react';

interface SearchNavBarProps {
  title: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onRefresh?: () => void;
  addButtonTitle?: string;
  onAddClick?: () => void;
  titleAndButton?: boolean;
  disabled?: boolean;
  clickButton?: boolean
}

export const SearchNavBar: React.FC<SearchNavBarProps> = ({
  title,
  placeholder = AppStrings.SEARCH_NAV_BAR.PLACEHOLDER,
  value = "",
  onChange = () => {},
  onRefresh = () => {},
  addButtonTitle = AppStrings.SEARCH_NAV_BAR.REMITTER_ADD_BUTTON,
  onAddClick = () => {},
  titleAndButton = true,
  disabled = false,
  clickButton = true
}) => {
  return (
    <div className={styles.nav.container}>
      <div className={styles.nav.row}>

        {/* LEFT TITLE */}
        <Typograpy
          tagType="div"
          text={title}
          className={styles.nav.title}
        />

        {/* RIGHT SECTION */}
        <div className={styles.nav.right}>

          {/* SEARCH BOX */}
          {titleAndButton && (
          <div className={styles.search.wrapper}>
            
            {/* Left Search Icon */}
            <div className={styles.search.iconLeft}>
              <SearchIcon fillColor="fill-grey-1550" />
            </div>

            {/* Right Clear Icon */}
            {value && (
              <button
                className={styles.search.iconRight}
                onClick={() => onChange("")}
              >
                <CircleXCloseMark />
              </button>
            )}

            {/* INPUT FIELD */}
            <input
              type="text"
              value={value}
              autoComplete="off"
              placeholder={placeholder}
              onChange={(e) => {
                const val = e.target.value;
                onChange(val);
              }}
              className={clsx(styles.search.input)}
            />
          </div>
          )}

          {titleAndButton && (
          <RefreshButton
            refreshing={false}
            onClick={onRefresh}
          />
          )}

          {/* ADD NEW BUTTON */}
          {clickButton && (
          <Button
            bgColor={disabled ? "bg-gray-300" : "bg-[#006EFF]"}
            fontStyle={{
              fontFamily: "font-Inter",
              fontSize: "text-sm",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{ borderRadius: "rounded-lg" }}
            className={disabled ? styles.nav.disableAddBtn : styles.nav.addBtn}
            onClickHandler={onAddClick}
            disabled={disabled}
          >
            <div className='flex items-center gap-1'>
              {titleAndButton && (<Plus width={15} height={15} />)}
              {addButtonTitle}
            </div>
          </Button>
          )}

        </div>
      </div>
    </div>
  );
};

interface Props {
  refreshing?: boolean;
  onClick?: () => void;
}

export default function RefreshButton({ refreshing = false, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      disabled={refreshing}
      className={clsx(
        "group w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-200",
        "hover:bg-blue-50",
        refreshing && "opacity-60 cursor-not-allowed"
      )}
    >
      <RefreshCw
        size={15}
        className={clsx(
          "transition-all duration-300",

          /* When refreshing → BLACK + spin */
          refreshing && "text-black animate-spin",

          /* When NOT refreshing → Black normally, Blue on hover */
          !refreshing && "text-black group-hover:text-blue-600"
        )}
      />
    </button>
  );
}
